<template>
  <div id="quizcontainter">
    <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <h1 class="display-4">Game-admin</h1>
      <p class="lead">Dit is de admin pagina voor het spel.</p>
    </div>
    <div class="container">
      <ConnectionErrors />
      <div class="card-deck mb-3">
        <!-- New Quiz -->
        <div class="card mb-4 box-shadow text-center">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Instellingen</h4>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group">
                <!-- Game Id -->
                <div class="form-group">
                  <label for="username">Game id:</label>
                  <input class="form-control" v-model="createdGame.Id" label="Game id" type="number" disabled />
                </div>
                <!-- Choose quiz -->
                <div class="form-group">
                  <label for="username">Kies de quiz:</label>
                  <input class="form-control" v-model="quizname" label="quizname">
                  <!--<select class="form-control" v-model="quizname" label="quizname" @change="setQuiz()">
                    <option>bijbelquiz1</option>
                  </select>-->
                  <button @click.prevent="setQuiz()" type="submit" class="btn btn-primary mb-2">Zet quiz</button>
                </div>
                <!-- Quiz started -->
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="createdGame.IsStarted" disabled>
                  <label for="username">Game is gestart</label>
                </div>
                <!-- Current question -->
                <div class="card">
                  <div class="card-header">
                    <h4 class="my-0 font-weight-normal" v-if="currentQuestion">{{ currentQuestion.SequenceNumber}}: {{ currentQuestion.QuestionText }}</h4>
                  </div>
                  <div class="progress" v-if="tick">
                    <div class="progress-bar" role="progressbar" :aria-valuenow="1 - tick.Percentage" aria-valuemin="0" aria-valuemax="100" v-bind:style="{ width: tickPercentage }">{{ tick.Remaining }} seconden</div>
                  </div>
                  <h1 class="card-title pricing-card-title" v-if="gameState">{{ gameState.TotalAnswers }} <small class="text-muted">/ {{ gameState.TotalUsers }}</small></h1>
                </div>
                <!-- Buttons -->
                <button v-if="!createdGame.IsStarted && isConnected" @click.prevent="startGame()" type="submit" class="btn btn-primary mb-2">Game starten</button>
                <button v-if="createdGame.IsStarted && isConnected" @click.prevent="nextQuestion()" type="submit" class="btn btn-primary mb-2">Volgende vraag</button>
              </div>
            </form>
          </div>
        </div>
        <div class="card mb-4 box-shadow text-center">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal" v-if="quiz">Quiz: {{ quiz.Name }}</h4>
            <h4 class="my-0 font-weight-normal" v-if="!quiz">Kies een quiz</h4>
          </div>
          <div class="card-body">
            <!-- Show questions -->
            <QuestionsAdmin />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConnectionErrors from '@/components/ConnectionErrors.vue'
import QuestionsAdmin from '@/components/QuestionsAdmin.vue'

export default {
  name: 'quiz',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      gameError: 'quiz/gameError',
      connectionError: 'quiz/connectionError',
      isConnectionFailed: 'quiz/connectionFailed',
      createdGame: 'quiz/createdGame',
      quiz: 'quiz/quiz',
      gameState: 'quiz/gameState',
      currentQuestion: 'quiz/currentQuestion',
      tick: 'quiz/tick',
      tickPercentage: 'quiz/tickPercentage'
    })
  },
  components: {
    ConnectionErrors,
    QuestionsAdmin
  },
  data () {
    return {
      quizname: '',
      QuestionsAdmin
    }
  },
  methods: {
    startGame () {
      this.$store.dispatch('quiz/startGame')
    },
    nextQuestion () {
      this.$store.dispatch('quiz/nextQuestion')
    },
    setQuiz () {
      this.$store.dispatch('quiz/setQuizname', this.quizname)
    }
  }
}
</script>
